import React from 'react'
import FeedsSystem from '../../../../feedsSystem/FeedsSystem'
import withStyles from '@mui/styles/withStyles'
import DeletedSharedPost from './DeletedSharedPost'
import DarkModeColorCoder from '../../../../smallComponents/DarkModeColorCoder'

const styles = () => ({
  sharedContentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    padding: 10,
    paddingTop: 0,
    borderRadius: 15,
    margin: '-10px 10px auto 10px',
  },
})

const SharedPostMiddle = ({ classes, postProps }) => {
  const { isDarkModeActive, sharedPost, sharedPostUser, socket, setPosts } =
    postProps
  return (
    <section
      className={classes.sharedContentWrapper}
      style={{
        border: `1px solid ${
          isDarkModeActive
            ? DarkModeColorCoder('Grey_2x_light')
            : 'rgb(0, 119, 181)'
        }`,
      }}
    >
      {sharedPost ? (
        <FeedsSystem
          feedsSystemProps={{
            // data of the post to be shared
            post: sharedPost,
            isUsedIn: 'shareSystem',
            hideRightOptions: true,
            hideBottom: true,
            isDarkModeActive,
            user: sharedPostUser,
            socket,
            hideAddUserIcon: true,
            setPosts,
            shared: true,
          }}
        />
      ) : (
        <DeletedSharedPost />
      )}
    </section>
  )
}

const WrappedSharedPostMiddle = withStyles(styles)(SharedPostMiddle)

export default WrappedSharedPostMiddle
